import { cn } from '@lyearn/style';

import { cardSizeMobileStyles, cardSizeStyles } from '../styles';

export const JOURNEY_CARD_SIZE = {
  web: {
    height: 21.2,
    width: 32.8,
  },
};

export const LEGACY_JOURNEY_CARD_SIZE = {
  web: {
    height: 27.6,
    width: 24.8,
  },
};

export const journeyCardSizeStyles = cardSizeStyles(JOURNEY_CARD_SIZE.web);
export const legacyJourneyCardSizeStyles = cardSizeStyles(LEGACY_JOURNEY_CARD_SIZE.web);

export const DEFAULT_CARD_IMAGE_HEIGHT = {
  web: 21.6,
  mobile: 10.8,
};

export const DEFAULT_CARD_SIZE = {
  web: {
    height: 42,
    width: 33.9,
  },
  mobile: {
    height: 29.6,
    width: 26.4,
  },
};

export const defaultCardSizeStyles = cn(
  cardSizeStyles(DEFAULT_CARD_SIZE.web),
  cardSizeMobileStyles(DEFAULT_CARD_SIZE.mobile),
);
